import { render, staticRenderFns } from "./TokenView.vue?vue&type=template&id=6079c8e0&scoped=true&"
import script from "./TokenView.vue?vue&type=script&lang=ts&"
export * from "./TokenView.vue?vue&type=script&lang=ts&"
import style0 from "./TokenView.vue?vue&type=style&index=0&id=6079c8e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6079c8e0",
  null
  
)

export default component.exports